import apiConfig from "constants/apiConfig";
import { ApplicationCost, ApplicationPosts, CampaignApplication, ShortlistedSummary } from "types/campaign/applications";
import axiosClient from "utils/axiosClient";

const withCampaignId = (url: string, campaignId: string) => url.replace('<campaignId>', campaignId);
const withApplicationId = (url: string, applicationId: string) => url.replace('<applicationId>', applicationId);
const withInfluencerId = (url: string, influencerId: string) => url.replace('<influencerId>', influencerId);

export const fetchCampaignApplications = async (campaignId: string, payload: Record<string, unknown>) => {
    const response = await axiosClient.get(withCampaignId(apiConfig.FETCH_CAMPAIGN_APPLICATIONS.url, campaignId), {
        params: { limit: 24, ...payload },
    });

    return response.data;
};

export const fetchApplication = async (campaignId: string, applicationId: string): Promise<CampaignApplication> => {
    const response = await axiosClient.get(
        withApplicationId(withCampaignId(apiConfig.FETCH_APPLICATION.url, campaignId), applicationId)
    );

    return response.data.application;
};

export const processApplication = async (
    campaignId: string,
    applicationId: string,
    payload: Record<string, unknown>
) => {
    const response = await axiosClient.put(
        withApplicationId(withCampaignId(apiConfig.PROCESS_APPLICATION.url, campaignId), applicationId),
        payload
    );

    return response.data;
};

export const bookmarkApplciation = async (
    campaignId: string,
    applicationId: string,
    bookmark: 'y' | 'n',
    force: boolean = false
) => {
    const response = await axiosClient.post(
        withApplicationId(withCampaignId(apiConfig.BOOKMARK_APPLICATION.url, campaignId), applicationId),
        { bookmark, force }
    );

    return response.data;
};

export const fetchApplicationMedia = async (
    campaignId: string,
    influencerId: string,
    payload: Record<string, unknown> = {}
): Promise<ApplicationPosts> => {
    const response = await axiosClient.get(
        withInfluencerId(withCampaignId(apiConfig.FETCH_APPLICATION_POSTS.url, campaignId), influencerId),
        { params: { sort: 'like_count', ...payload } }
    );

    return response.data;
};

export const fetchApplicationCost = async (
    campaignId: string,
    applicationId: string
): Promise<ApplicationCost> => {
    const response = await axiosClient.get(
        withApplicationId(withCampaignId(apiConfig.FETCH_APPLICATION_COST.url, campaignId), applicationId)
    );

    return response.data;
};

export const fetchShortlistedSummary = async (campaignId: string): Promise<ShortlistedSummary> => {
    const response = await axiosClient.get(withCampaignId(apiConfig.FETCH_SHORTLISTED_SUMMARY.url, campaignId));

    return response.data;
};

export const approveShortlistedApplication = async (campaignId: string) => {
    const response = await axiosClient.post(
        withCampaignId(apiConfig.APPROVE_SHORTLISTED_APPLICATION.url, campaignId)
    );

    return response.data;
};

export const rejectAllApplications = async (campaignId: string) => {
    const response = await axiosClient.post(
        withCampaignId(apiConfig.REJECT_ALL_APPLICATIONS.url, campaignId)
    );

    return response.data;
};

export const revertApplicationRejection = async (campaignId: string, applicationId: string) => {
    const response = await axiosClient.post(
        withApplicationId(withCampaignId(apiConfig.REVERT_APPLICATION_REJECTION.url, campaignId), applicationId)
    );

    return response.data;
};

export const updateApplicationQuotedOffer = async (
    campaignId: string,
    applicationId: string,
    quotedOffer: number
) => {
    const response = await axiosClient.post(
        withApplicationId(withCampaignId(apiConfig.UPDATE_APPLICATION_QUOTED_OFFER.url, campaignId), applicationId),
        { quoted_offer: quotedOffer }
    );

    return response.data;
};
